import {Component, input, OnInit} from '@angular/core';
import {Validators} from '@angular/forms';
import {StepWithAttachmentsComponent} from '../../base/step-with-attachments.component';
import {SubsidyType} from '../../models/subsidy-type.type';

@Component({
	selector: 'tvsub-manual-step',
	templateUrl: './manual-step.component.html',
	styleUrls: ['./manual-step.component.scss'],
	standalone: false
})
export class ManualStepComponent extends StepWithAttachmentsComponent implements OnInit {
	manual = input.required<string>();
	name = input.required<string>();
	type = input.required<SubsidyType>();
	handleiding = input<string>('handleiding');

	constructor() {
		super();
	}

	ngOnInit() {
		this.manuallySetSubsidyType(this.type());

		this.form = this.fb.group({
			accept: [false, Validators.requiredTrue],
		});
	}

	override getData(formData: any): any {
		return {};
	}
}
